/**
 * GridCellFill — one of 5 cockpit loader variants.
 * Ported from landing/components/cockpit/loaders/GridCellFill.tsx.
 */

const CELL_ORDER = [0, 1, 2, 5, 8, 7, 6, 3, 4]; // TL, TC, TR, MR, BR, BC, BL, ML, CENTER

interface Props {
  progress: number; // 0-100
}

export default function GridCellFill({ progress }: Props) {
  const activeCells = Math.round((progress / 100) * 9);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-8">
      <div className="grid grid-cols-3 gap-2">
        {Array.from({ length: 9 }).map((_, cellIndex) => {
          const orderIndex = CELL_ORDER.indexOf(cellIndex);
          const isActive = orderIndex < activeCells;
          const isCenter = cellIndex === 4;
          const isLatest = orderIndex === activeCells - 1;

          return (
            <div
              key={cellIndex}
              className="w-14 h-14 sm:w-20 sm:h-20 transition-all duration-300 ease-out"
              style={{
                border: isActive
                  ? isCenter
                    ? '2px solid var(--color-orange)'
                    : '1px solid var(--color-orange)'
                  : '1px solid var(--color-border)',
                background: isActive
                  ? isCenter
                    ? 'oklch(from var(--color-orange) l c h / 0.12)'
                    : 'oklch(from var(--color-orange) l c h / 0.06)'
                  : 'var(--color-surface-card)',
                boxShadow: isCenter && isActive
                  ? '0 0 20px oklch(from var(--color-orange) l c h / 0.25)'
                  : isLatest && isActive
                    ? '0 0 10px oklch(from var(--color-orange) l c h / 0.15)'
                    : 'none',
                transform: isLatest ? 'scale(1.05)' : 'scale(1)',
              }}
            />
          );
        })}
      </div>
      <div className="font-mono text-xl font-bold text-txt-primary tabular-nums">
        {Math.round((activeCells / 9) * 100)}%
      </div>
    </div>
  );
}
